import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { ILookupBase } from '../../../../Models/ILookupBase';
import { LookupService } from 'src/app/Services/LookupService';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { FormPresentLevelsService } from "../../../../Services/FormPresentLevelsService";
import { IFormPresentLevels } from "../../../../Models/Forms/IFormPresentLevels";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';


@Component({
  selector: 'PresentLevels',
  templateUrl: './PresentLevels.component.html',
  styleUrls: ['./PresentLevels.component.css']
})


export class FormPresentLevelsComponent extends SpinnerBase implements OnInit {

  _myGlobals: Globals;
  reportParamArray: IReportParameter[];
  //public showSpinner: boolean = false;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  _lookupService: LookupService;
  formPresentLevelsDB: any = [];
  TestingStandardMet: any = [];
  LevelOfUnderstanding: any = [];
  AssessmentLevel: any = [];
  TestingStandardLevel: any = [];
  ELPTestOptions: ILookupBase[] = [];
  ELProficiencyDescriptorOptions: ILookupBase[] = [];
  ELLevelOptions: ILookupBase[] = [];
  minVisionHearingDate: Date;

  constructor(
    private globals: Globals, reportService: ReportService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService,
    private _formPresentLevelsService: FormPresentLevelsService) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
  }

  ngOnInit(): void {
    this.LoadFormPresentLevelsDetails();
    this.LoadLookupValues();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.scrollToTop();
    this.minVisionHearingDate = new Date();
    this.minVisionHearingDate.setDate(this._myGlobals.todaysDate.getDate() - 1126); //3years + 1 month
    this.successMessages = [];
    this.errorMessages = [];
  }

  LoadFormPresentLevelsDetails(): void {
    this._formPresentLevelsService.getFormPresentLevels(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormPresentLevels) => {
        this.formPresentLevelsDB = res
        this.formPresentLevelsDB.communicationDevelopment = this.formPresentLevelsDB.communicationDevelopment == null ? null : this.formPresentLevelsDB.communicationDevelopment.toString();
        // ELA
        this.formPresentLevelsDB.elaOverall = this.formPresentLevelsDB.elaOverall == null ? null : this.formPresentLevelsDB.elaOverall.toString();
        this.formPresentLevelsDB.elaReading = this.formPresentLevelsDB.elaReading == null ? null : this.formPresentLevelsDB.elaReading.toString();
        this.formPresentLevelsDB.elaResearchInquiry = this.formPresentLevelsDB.elaResearchInquiry == null ? null : this.formPresentLevelsDB.elaResearchInquiry.toString();
        this.formPresentLevelsDB.elaSpeakingListening = this.formPresentLevelsDB.elaSpeakingListening == null ? null : this.formPresentLevelsDB.elaSpeakingListening.toString();
        this.formPresentLevelsDB.elaWriting = this.formPresentLevelsDB.elaWriting == null ? null : this.formPresentLevelsDB.elaWriting.toString();
        this.formPresentLevelsDB.eldTest = this.formPresentLevelsDB.eldTest == null ? null : this.formPresentLevelsDB.eldTest.toString();
        this.formPresentLevelsDB.elaTestDate = this.formPresentLevelsDB.elaTestDate == null ? null : new Date(this.formPresentLevelsDB.elaTestDate);
        // Math
        this.formPresentLevelsDB.mathOverall = this.formPresentLevelsDB.mathOverall == null ? null : this.formPresentLevelsDB.mathOverall.toString();
        this.formPresentLevelsDB.mathConcernsProcedures = this.formPresentLevelsDB.mathConcernsProcedures == null ? null : this.formPresentLevelsDB.mathConcernsProcedures.toString();
        this.formPresentLevelsDB.mathProblemSolvingAnalysis = this.formPresentLevelsDB.mathProblemSolvingAnalysis == null ? null : this.formPresentLevelsDB.mathProblemSolvingAnalysis.toString();
        this.formPresentLevelsDB.mathCommunicationReasoning = this.formPresentLevelsDB.mathCommunicationReasoning == null ? null : this.formPresentLevelsDB.mathCommunicationReasoning.toString();
        this.formPresentLevelsDB.mathTestDate = this.formPresentLevelsDB.mathTestDate == null ? null : new Date(this.formPresentLevelsDB.mathTestDate);
        // CAA
        this.formPresentLevelsDB.caaelaScore = this.formPresentLevelsDB.caaelaScore == null ? null : this.formPresentLevelsDB.caaelaScore.toString();
        this.formPresentLevelsDB.caaMathScore = this.formPresentLevelsDB.caaMathScore == null ? null : this.formPresentLevelsDB.caaMathScore.toString();
        this.formPresentLevelsDB.caaScienceScore = this.formPresentLevelsDB.caaScienceScore == null ? null : this.formPresentLevelsDB.caaScienceScore.toString();
        // ELP
        this.formPresentLevelsDB.elpTestId = this.formPresentLevelsDB.elpTestId == null ? null : this.formPresentLevelsDB.elpTestId.toString();
        this.formPresentLevelsDB.elpListeningDescriptorId = this.formPresentLevelsDB.elpListeningDescriptorId == null ? null : this.formPresentLevelsDB.elpListeningDescriptorId.toString();
        this.formPresentLevelsDB.elpOralLanguageDescriptorId = this.formPresentLevelsDB.elpOralLanguageDescriptorId == null ? null : this.formPresentLevelsDB.elpOralLanguageDescriptorId.toString();
        this.formPresentLevelsDB.elpOverallDescriptorId = this.formPresentLevelsDB.elpOverallDescriptorId == null ? null : this.formPresentLevelsDB.elpOverallDescriptorId.toString();
        this.formPresentLevelsDB.elpReadingDescriptorId = this.formPresentLevelsDB.elpReadingDescriptorId == null ? null : this.formPresentLevelsDB.elpReadingDescriptorId.toString();
        this.formPresentLevelsDB.elpSpeakingDescriptorId = this.formPresentLevelsDB.elpSpeakingDescriptorId == null ? null : this.formPresentLevelsDB.elpSpeakingDescriptorId.toString();
        this.formPresentLevelsDB.elpWritingDescriptorId = this.formPresentLevelsDB.elpWritingDescriptorId == null ? null : this.formPresentLevelsDB.elpWritingDescriptorId.toString();
        this.formPresentLevelsDB.elpWrittenLanguageDescriptorId = this.formPresentLevelsDB.elpWrittenLanguageDescriptorId == null ? null : this.formPresentLevelsDB.elpWrittenLanguageDescriptorId.toString();
        //Health
        //this.formPresentLevelsDB.hasHealthPlan = this.formPresentLevelsDB.hasHealthPlan == null ? false : this.formPresentLevelsDB.hasHealthPlan as Boolean;

        // Dates
        this.formPresentLevelsDB.hearingTestDate = this.formPresentLevelsDB.hearingTestDate == null ? null : new Date(this.formPresentLevelsDB.hearingTestDate);
        this.formPresentLevelsDB.visionTestDate = this.formPresentLevelsDB.visionTestDate == null ? null : new Date(this.formPresentLevelsDB.visionTestDate);


        this.formPresentLevelsDB.notApplicableCAA = this.formPresentLevelsDB.notApplicableCAA == null ? false : this.formPresentLevelsDB.notApplicableCAA as Boolean;
        this.formPresentLevelsDB.notApplicableELD = this.formPresentLevelsDB.notApplicableELD == null ? false : this.formPresentLevelsDB.notApplicableELD as Boolean;
        this.formPresentLevelsDB.notApplicablePhysEd = this.formPresentLevelsDB.notApplicablePhysEd == null ? false : this.formPresentLevelsDB.notApplicablePhysEd as Boolean;
        this.formPresentLevelsDB.notApplicableSBAC = this.formPresentLevelsDB.notApplicableSBAC == null ? false : this.formPresentLevelsDB.notApplicableSBAC as Boolean;

      },
        err => console.error(err)
      );
  }

  LoadLookupValues(): void {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.TestingStandardMet])
      .subscribe((res: ILookupBase[]) => {
        this.TestingStandardMet = res
      },
        err => console.error(err)
      );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.LevelOfUnderstanding])
      .subscribe((res: ILookupBase[]) => {
        this.LevelOfUnderstanding = res
      },
        err => console.error(err)
      );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.AssessmentLevel])
      .subscribe((res: ILookupBase[]) => {
        this.AssessmentLevel = res
      },
        err => console.error(err)
      );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.TestingStandardLevel])
      .subscribe((res: ILookupBase[]) => {
        this.TestingStandardLevel = res
      },
        err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ELPTest])
      .subscribe((res: ILookupBase[]) => {
        this.ELPTestOptions = [] as ILookupBase[];
        this.ELPTestOptions.push({ label: 'Select Choice', value: null, shortText: 'Select Choice', updatedOn: null });
        this.ELPTestOptions.push.apply(this.ELPTestOptions, res);
      },
        err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ELProficiencyDescriptor])
      .subscribe((res: ILookupBase[]) => {
        this.ELProficiencyDescriptorOptions = [] as ILookupBase[];
        this.ELProficiencyDescriptorOptions.push({ label: 'Select Choice', value: null, shortText: 'Select Choice', updatedOn: null });
        this.ELProficiencyDescriptorOptions.push.apply(this.ELProficiencyDescriptorOptions, res);
      },
        err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ELLevel])
      .subscribe((res: ILookupBase[]) => {
        this.ELLevelOptions = [] as ILookupBase[];
        this.ELLevelOptions.push({ label: 'Select Choice', value: null, shortText: 'Select Choice', updatedOn: null });
        this.ELLevelOptions.push.apply(this.ELLevelOptions, res);
      },
        err => console.error(err)
      );

  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the Present Levels
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;
    this.showSpinner = true;

    //update values
    this.timeStamp = new Date();
    this._formPresentLevelsService.insertUpdateFormPresentLevels(this.formPresentLevelsDB)
      .subscribe((res: IFormPresentLevels) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully.  Record Id: ', detail: res.id.toString() + ' at: ' + this.timeStamp.toLocaleTimeString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.showSpinner = false;
        this.LoadFormPresentLevelsDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
          this.showSpinner = false;
        }
      )

  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormPresentLevelsDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False'  },
      { parameterName: 'FormInstanceID', parameterValue: this.formPresentLevelsDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formPresentLevelsDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formPresentLevelsDB.rdlFileNameSpanish, this.reportParamArray);
  }

}


